import React, { useContext } from 'react'
import { useState, useEffect } from 'react';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import axios from 'axios';
import GlobalContext from './GlobalContext';
import { child, get, getDatabase, ref, set } from 'firebase/database';
import { toggleRole } from '../Tools/tools';

function EditarUsuario(props) {
    const [show, setShow] = useState(false);
    const [updateButtonVisible, setUpdateButtonVisible] = useState(true);

    const { globalData, setGlobalData } = useContext(GlobalContext);

    const handleClose = () => {
        setFormData(originalData);
        setShow(false);
    };

    const handleShow = () => setShow(true);

    const [originalData, setOriginalData] = useState(props.user);
    const [formData, setFormData] = useState(props.user);
    const [isChanged, setIsChanged] = useState(false);
    const [adminPerm, setAdminPerm] = useState(false);

    const db = getDatabase()

    useEffect(() => {
        if (props.user.perm) {
            const roles = Object.entries(props.user.perm)
                .filter(([key]) => key !== 'company')
                .map(([, value]) => value);
    
            setAdminPerm(roles.includes('admin'));
        }
    }, [props.user.perm]);
    
    useEffect(() => {
        setIsChanged(JSON.stringify(formData) !== JSON.stringify(originalData));
    }, [formData, props.user]);

    

    const updatePermission = (e) => {
        toggleRole(e.target.checked, "admin")
    }

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        setUpdateButtonVisible(false);
        e.preventDefault();
        if (isChanged) {

            axios.post(
                `${globalData.apiHost}/edituser`,
                formData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': process.env.REACT_APP_BACKEND_SECRET
                    }
                }
            ).then(() => {
                setUpdateButtonVisible(true);
                props.refreshListaUsuarios();
                setOriginalData(formData);
                handleClose();
            }).catch(() => {

            })
        }
    };

    return (
        <>
            <Button variant="primary" size="sm" className="ms-2" title="Editar" onClick={handleShow}>
                <i className="bi bi-pencil-square"></i>
            </Button>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Form onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>Editar Usuário</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h5>Informações Pessoais</h5>
                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                            // disabled
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Nome</Form.Label>
                            <Form.Control
                                type="text"
                                name="displayName"
                                value={formData.displayName}
                                onChange={handleChange}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Telefone</Form.Label>
                            <Form.Control
                                type="text"
                                name="phoneNumber"
                                value={formData.phoneNumber}
                                onChange={handleChange}
                            />
                        </Form.Group>
                        <div className='d-flex justify-content-end'>
                            <Button variant="secondary" className='me-1'
                                onClick={handleClose}>
                                Cancelar
                            </Button>
                            {updateButtonVisible &&
                                <div style={{ 'width': '85px' }}>

                                    <Button
                                        variant="success"
                                        type="submit"
                                        disabled={!isChanged}
                                    >
                                        Atualizar
                                    </Button>
                                </div>
                            }
                            {!updateButtonVisible &&
                                <div style={{ 'width': '85px' }}>
                                    <div className='w-100 d-flex justify-content-center align-items-center'>
                                        <Spinner animation="border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </Spinner>
                                    </div>
                                </div>
                            }
                        </div>

                        <hr />
                        <h5>Permissões</h5>
                        <Form.Check
                            type="switch"
                            id="custom-switch"
                            label="Administrador"
                            onChange={(e) => updatePermission(e)}
                            checked={adminPerm}
                        />
                    </Modal.Body>
                </Form>
            </Modal>
        </>
    );
}

export default EditarUsuario